import React from 'react';
import { Stripe } from '../types';

export interface InjectedProps {
  idealPaymentInProgress: boolean;
  stripe?: Stripe;
}

export const withStripe = (Component: any) => (props: any) => {
  const { supplierId, stripe, idealPaymentInProgress, ...rest } = props;

  return (
    <Component
      {...rest}
      supplierId={supplierId}
      idealPaymentInProgress={idealPaymentInProgress}
      stripe={stripe}
    />
  );
};
